export var ProcessAction;
(function (ProcessAction) {
    ProcessAction["RESTART"] = "restart";
    ProcessAction["REBOOT"] = "reboot";
    ProcessAction["SHUTDOWN"] = "shutdown";
    ProcessAction["POWER_ON"] = "power_on";
    ProcessAction["INSTALL_ANYDESK"] = "install_anydesk";
    ProcessAction["TAKE_SCREENSHOT"] = "take_screenshot";
    ProcessAction["TAKE_SCREENSHOT_DEVTOOLS"] = "take_screenshot_devtools";
    ProcessAction["SEND_TELEMETRY"] = "send_telemetry";
    ProcessAction["RUN_MIGRATION"] = "run_migration";
})(ProcessAction || (ProcessAction = {}));
//# sourceMappingURL=ProcessActionServiceInterface.js.map